<template>
    <v-container fluid grid-list-md>
        <container-sizes></container-sizes>
    </v-container>
</template>
<script>
  import ContainerSizes from '../components/ContainerSizes/List.vue';

  export default {
    components: {
      ContainerSizes
    }
  };
</script>
